import { render, staticRenderFns } from "./ProductWizardProvider.vue?vue&type=template&id=34515a0e&"
import script from "./ProductWizardProvider.vue?vue&type=script&lang=js&"
export * from "./ProductWizardProvider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports